import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiClient} from './apiClient';

@Injectable()
export class ReportService {
  private basePath;

  constructor(private http: ApiClient) {
    this.basePath = '/api/district';
  }

  public getReport(districtId: string, report: string): Observable<string> {
    const path = `${this.basePath}/${districtId}/reports/${report}`;
    return this.http.get(path, {responseType: 'text'});
  }
}
